// extracted by mini-css-extract-plugin
export default {"nav":"pagination_nav__oJhHN","button":"pagination_button__7glF9"};